/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Submission status of observation report
 * @export
 * @enum {string}
 */

export const ObservationReportStatus = {
    Success: 'SUCCESS',
    PartialSuccessSomeDocumentsFail: 'PARTIAL_SUCCESS_SOME_DOCUMENTS_FAIL'
} as const;

export type ObservationReportStatus = typeof ObservationReportStatus[keyof typeof ObservationReportStatus];



